import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const primary = "mt-8 h-12 w-full rounded-full bg-brand text-[15px] font-semibold text-white hover:bg-brand-hover";
const secondary = "mt-3 h-12 w-full rounded-full bg-black/5 text-[15px] font-medium text-ink hover:bg-black/10";

function Shell({ children, testId }) {
  return (
    <div className="stp-bg flex min-h-screen items-center justify-center px-5">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="stp-card w-full max-w-md rounded-3xl p-10 text-center" data-testid={testId}>
        {children}
      </motion.div>
    </div>
  );
}

export function PaymentSuccess() {
  const [state, setState] = useState("polling");
  const { refresh } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    refresh().then((u) => setState(u?.plan_status === "active" ? "paid" : "timeout")).catch(() => setState("timeout"));
  }, [refresh]);

  return (
    <Shell testId="payment-success">
      {state === "polling" && <><CircleNotch size={48} className="mx-auto animate-spin text-brand" /><h1 className="mt-5 font-display text-3xl font-semibold text-ink">Confirming payment…</h1><p className="mt-2 text-mist">This only takes a moment.</p></>}
      {state === "paid" && <><CheckCircle size={60} weight="fill" className="mx-auto text-[#34C759]" /><h1 className="mt-5 font-display text-3xl font-semibold text-ink">You're all set.</h1><p className="mt-2 text-mist">Your plan is active. A receipt is on its way to your inbox.</p><button data-testid="go-to-app-button" onClick={() => navigate("/app")} className={primary}>Open workspace</button></>}
      {state === "timeout" && <><CircleNotch size={48} className="mx-auto text-mist" /><h1 className="mt-5 font-display text-3xl font-semibold text-ink">Still processing</h1><p className="mt-2 text-mist">Your plan will activate shortly.</p><button data-testid="continue-to-app-button" onClick={() => navigate("/app")} className={primary}>Continue to workspace</button></>}
    </Shell>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <Shell testId="payment-cancel">
      <XCircle size={60} weight="fill" className="mx-auto text-[#FF3B30]" />
      <h1 className="mt-5 font-display text-3xl font-semibold text-ink">Checkout cancelled</h1>
      <p className="mt-2 text-mist">No charge was made. You can upgrade anytime.</p>
      <button data-testid="back-to-pricing-button" onClick={() => navigate("/pricing")} className={primary}>Back to pricing</button>
      <button data-testid="cancel-to-app-button" onClick={() => navigate("/app")} className={secondary}>Go to workspace</button>
    </Shell>
  );
}
